import React from 'react'

const Logo = () => {
    return (
       <img src="/images/yotta-logo.svg" style={{width: '200px'}} />
    )
}

export default Logo
